import { appendUserMessage } from "./appendUserMessage";
import { renderMessage } from "./renderMessage";
import { updateCredits } from "./updateCredits";
import { handleAjaxError } from "./handleAjaxError";
import { scrollToChatBottom } from "./scrollToChatBottom";
import { messageQueue } from "./messageQueue";
import { messageResponseEvent } from "../events/messageResponseEvent";
import {
    setContentGeneratorProgress,
    startContentGeneratorProgressSimulation,
    stopContentGeneratorProgressSimulation
} from "../components/contentGeneratorModal";

export function convertMessageToImage(message) {
    // no-op: using document-level delegation below
}

if (!window._convertMessageToImageDelegated) {
    window._convertMessageToImageDelegated = true;

    $(document).on('click', '.g-chatform-message-create-image', function (event) {
        event.preventDefault();
        event.stopPropagation();
        convertMessage($(this));
    });
}

function convertMessage(submitBtn) {
    let chatId = submitBtn.closest('.g-chatform').attr('id');
    let messageId = submitBtn.closest('.g-chatform-message').attr('data-id');

    if (submitBtn.hasClass('is-loading')) {
        return;
    }

    submitBtn.addClass('is-loading');

    let chatForm = submitBtn.closest('.g-chatform');

    let userMessageTemplate = appendUserMessage(chatForm, 'image');


    jQuery.ajax({
        url: growtype_chat_ajax.url,
        type: 'post',
        data: {
            message_id: messageId,
            action: growtype_chat_ajax.convert_message_to_image,
            nonce: growtype_chat_ajax.nonce,
        },
        beforeSend: function () {
            startContentGeneratorProgressSimulation(userMessageTemplate);
        },
        success: function (response) {
            setContentGeneratorProgress(userMessageTemplate, 100);
            setTimeout(() => {
                stopContentGeneratorProgressSimulation(userMessageTemplate);
            }, 500);

            messageQueue.addToQueue(async () => {
                userMessageTemplate.show();
                scrollToChatBottom();

                /**
                 * Update credits
                 */
                updateCredits(response.data.existing_credits);

                /**
                 * Dispatch event
                 */
                document.dispatchEvent(messageResponseEvent({
                    'response': response,
                }));

                await renderMessage(chatForm, response, userMessageTemplate);
            });

            submitBtn.removeClass('is-loading');
        },
        error: function (response) {
            stopContentGeneratorProgressSimulation(userMessageTemplate);
            userMessageTemplate.remove();
            handleAjaxError(response, submitBtn);
        }
    });
}
